// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1Ja79","title":"BackImages_title__2CJkB","images":"BackImages_images__1hjpA"};